module.exports = __webpack_public_path__ + "assets/img/flic-internet-request-4.4c00f130.png";